module.exports = __webpack_public_path__ + "static/media/country_it.b696cfc0.webp";